import { QueryClient, useQuery } from '@tanstack/react-query';
import { isBefore } from 'date-fns';

import { GetFixBesluit200 } from '@/api/generated/digiVAPI.schemas';
import { useBesluit } from '@/api/queries/besluit';

type UseMaxBeginGeldigheidProps = {
  bedrijfId: string;
};

export const useMaxBeginGeldigheid = ({
  bedrijfId,
}: UseMaxBeginGeldigheidProps) => {
  return useQuery(getMaxBeginGeldigheidQueryOptions({ bedrijfId }));
};

export const ensureQueryDataMaxBeginGeldigheid = async ({
  bedrijfId,
  queryClient,
}: UseMaxBeginGeldigheidProps & { queryClient: QueryClient }) => {
  const response = await queryClient.ensureQueryData(
    getMaxBeginGeldigheidQueryOptions({ bedrijfId })
  );

  return selectMaxBeginGeldigheid(response);
};

const getMaxBeginGeldigheidQueryOptions = ({
  bedrijfId,
}: UseMaxBeginGeldigheidProps) => {
  return useBesluit.getOptions(
    {
      page: 1,
      size: 1,
      filter: [
        {
          model: 'Bedrijf',
          field: 'ID',
          op: 'eq',
          value: bedrijfId,
        },
      ],
      sort: [
        {
          model: 'Besluit',
          field: 'Begin_Geldigheid',
          direction: 'desc',
        },
      ],
    },
    {
      select: selectMaxBeginGeldigheid,
    }
  );
};

const selectMaxBeginGeldigheid = ({ objects }: GetFixBesluit200) => {
  const maxBeginGeldigheid = objects?.[0]?.Begin_Geldigheid;
  const now = new Date();
  now.setHours(0, 0, 0, 0);

  /**
   * If the max begin geldigheid is before today, return today
   */
  if (maxBeginGeldigheid && isBefore(new Date(maxBeginGeldigheid), now)) {
    return now;
  }

  return maxBeginGeldigheid ? new Date(maxBeginGeldigheid) : now;
};
